import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStep1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Lock",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14036",
		"data-name": "Group 14036",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11687",
				"data-name": "Path 11687",
				d: "M17,21H7a2,2,0,0,1-2-2V11A2,2,0,0,1,7,9H17a2,2,0,0,1,2,2v8A2,2,0,0,1,17,21Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11688",
				"data-name": "Path 11688",
				d: "M12,17.09V14.5",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11689",
				"data-name": "Path 11689",
				d: "M12.53,13.22a.75.75,0,1,1-1.061,0,.75.75,0,0,1,1.061,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11690",
				"data-name": "Path 11690",
				d: "M8,9V7H8a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4h0V9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11691",
		"data-name": "Path 11691",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgStep1;
